import { env } from '@/utils/constants/env';
import { axiosInstance } from '@/utils/lib/axios';
import { useQuery } from '@tanstack/react-query';

export type HolidaysData = {
  id: string;
  title: string;
  start: string;
  end: string;
  startType: string;
  endType: string;
  isAllDay: boolean;
};

export const OdooService = {
  useGetHolidays: () => {
    return useQuery<HolidaysData[]>({
      queryKey: ['holidays'],
      queryFn: async () => {
        const { data } = await axiosInstance.get(env.apiTasklistBaseUrl + '/api/v1/odoo/employee/publicHolidays');

        return data.data;
      },
    });
  },
};
